module.exports = __webpack_public_path__ + "root-c2082cbd/093d7943a29bfda84a861b9f195a0bb6.svg";